
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DemoPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Redirect to landing page with demo section
    navigate('/#demo-section');
  }, [navigate]);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-8 text-center">Redirecting to Demo...</h1>
    </div>
  );
};

export default DemoPage;
